export default {
  container: 'font-inter text-[16px] leading-[24px] text-color-text sm:text-[18px] sm:leading-[32px] sm:pt-0 pt-24',
  heading: 'font-inter text-[24px] font-bold mb-[20px]',
};
